export default [
    {
        path: 'importar-laudo',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-importar-laudo' */
            '@/views/exame-laboratorial/importar-laudo/Index'
        ),
        redirect: 'importar-laudo/index',
        children: [
            {
                name: 'exame-laboratorial-importar-laudo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-importar-laudo' */
                    '@/views/exame-laboratorial/importar-laudo/List.vue'
                ),
            },
        ],
    }
]